// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "inventory": {
      "column": {
        "default": null,
        "name": "inventory",
        "null": false,
        "type": "integer"
      },
      "name": "inventory",
      "selected_by_default": null,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "number": {
      "column": {
        "default": null,
        "name": "number",
        "null": true,
        "type": "string"
      },
      "name": "number",
      "selected_by_default": null,
      "translated": false
    },
    "unit_cost": {
      "column": null,
      "name": "unit_cost",
      "selected_by_default": null,
      "translated": false
    },
    "unit_of_measure": {
      "column": {
        "default": null,
        "name": "unit_of_measure",
        "null": false,
        "type": "string"
      },
      "name": "unit_of_measure",
      "selected_by_default": null,
      "translated": false
    },
    "unit_price": {
      "column": null,
      "name": "unit_price",
      "selected_by_default": null,
      "translated": false
    },
    "unit_price_cents": {
      "column": {
        "default": null,
        "name": "unit_price_cents",
        "null": false,
        "type": "integer"
      },
      "name": "unit_price_cents",
      "selected_by_default": null,
      "translated": false
    },
    "vat": {
      "column": {
        "default": false,
        "name": "vat",
        "null": false,
        "type": "boolean"
      },
      "name": "vat",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "Product",
  "collectionKey": "products",
  "collectionName": "products",
  "i18nKey": "product",
  "camelizedLower": "product",
  "name": "Product",
  "nameDasherized": "product",
  "pluralName": "products",
  "ransackable_associations": [
    {
      "className": "Product::Translation",
      "collectionName": null,
      "foreignKey": "product_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "extra_product_id",
      "name": "extra_product_for",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "TenantShipmondoSetting",
      "collectionName": "tenant_shipmondo_settings",
      "foreignKey": "fixed_delivery_price_product_id",
      "name": "fixed_delivery_price_product_on_tenant_shipmondo_settings",
      "macro": "has_many",
      "resource_name": "TenantShipmondoSetting",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "introduction_price_product_id",
      "name": "introduction_price_product_plans",
      "macro": "has_many",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "product_id",
      "name": "invoice_lines",
      "macro": "has_many",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "max_price_product_id",
      "name": "max_price_product_plans",
      "macro": "has_many",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "member_price_id",
      "name": "member_price_for",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "member_price_product_id",
      "name": "member_price_product_plans",
      "macro": "has_many",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "min_price_product_id",
      "name": "min_price_product_plans",
      "macro": "has_many",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "non_member_price_id",
      "name": "non_member_price_for",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "non_member_price_product_id",
      "name": "non_member_price_product_plans",
      "macro": "has_many",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "product_id",
      "name": "photo_product",
      "macro": "has_one",
      "resource_name": "PhotoProduct",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "price_per_unit_product_id",
      "name": "price_per_unit_product_plans",
      "macro": "has_many",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "relational_member_price_id",
      "name": "relational_member_price_for",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "Product::Translation",
      "collectionName": null,
      "foreignKey": "product_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_in_inventio_at",
      "column": {
        "default": null,
        "name": "deleted_in_inventio_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "inventory",
      "column": {
        "default": null,
        "name": "inventory",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "number",
      "column": {
        "default": null,
        "name": "number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "unit_cost_cents",
      "column": {
        "default": null,
        "name": "unit_cost_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "unit_cost_currency",
      "column": {
        "default": null,
        "name": "unit_cost_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "unit_of_measure",
      "column": {
        "default": null,
        "name": "unit_of_measure",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "unit_price_cents",
      "column": {
        "default": null,
        "name": "unit_price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "unit_price_currency",
      "column": {
        "default": null,
        "name": "unit_price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vat",
      "column": {
        "default": false,
        "name": "vat",
        "null": false,
        "type": "boolean"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "product",
  "primaryKey": "id"
}

/** Frontend model for Product. */
export default class Product extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  inventory() {
    return this.readAttributeUnderscore("inventory")
  }

  /** @returns {boolean} */
  hasInventory() {
    const value = this.inventory()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  number() {
    return this.readAttributeUnderscore("number")
  }

  /** @returns {boolean} */
  hasNumber() {
    const value = this.number()

    return this._isPresent(value)
  }

  /** @returns {any} */
  unitCost() {
    return this.readAttributeUnderscore("unit_cost")
  }

  /** @returns {boolean} */
  hasUnitCost() {
    const value = this.unitCost()

    return this._isPresent(value)
  }

  /** @returns {string} */
  unitOfMeasure() {
    return this.readAttributeUnderscore("unit_of_measure")
  }

  /** @returns {boolean} */
  hasUnitOfMeasure() {
    const value = this.unitOfMeasure()

    return this._isPresent(value)
  }

  /** @returns {any} */
  unitPrice() {
    return this.readAttributeUnderscore("unit_price")
  }

  /** @returns {boolean} */
  hasUnitPrice() {
    const value = this.unitPrice()

    return this._isPresent(value)
  }

  /** @returns {number} */
  unitPriceCents() {
    return this.readAttributeUnderscore("unit_price_cents")
  }

  /** @returns {boolean} */
  hasUnitPriceCents() {
    const value = this.unitPriceCents()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  vat() {
    return this.readAttributeUnderscore("vat")
  }

  /** @returns {boolean} */
  hasVat() {
    const value = this.vat()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static sync(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "sync",
        collectionName: "products",
        type: "collection"
      },
      commandArgs
    ))
  }
}
